import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AboutBannarService } from 'src/app/components/about/aboutbannar/aboutbannar.service';
import { ContactUsService } from 'src/app/components/about/service/ContactUs.service';
import { eventpageService } from 'src/app/components/eventpage/eventpage.service';
import { PublicService } from 'src/app/components/PublicationsPage/PublicationsPage.service';
import { FormsService } from 'src/app/shared/service/forms.service';
import { ToastService } from 'src/app/shared/service/toast.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  email:FormControl = new FormControl(null);
  options:any;
  contactData:any;
  DataAbout: any;
  Datapublic: any;
  eventdata:any;
pupdata: any;

  constructor(
    private _FormsService:FormsService,
    private _ToastService:ToastService,
    private _ContactUsService:ContactUsService,
    private _AboutBannarService:AboutBannarService,
    private _eventpageService:eventpageService,
    private _PublicService:PublicService,
  ) {
    this._PublicService.watch().valueChanges.subscribe((result:any)=>{
      this.pupdata = result['data']['queryPublicationsPageContents'];
      console.log("pupMartina",result);
    })
    this._eventpageService.watch().valueChanges.subscribe((resultt:any)=>{
      this.eventdata = resultt['data']['queryEventsPageContents'];
      console.log("eventdata", this.eventdata);
    })
    this._AboutBannarService.watch().valueChanges.subscribe((result:any)=>{
      this.DataAbout = result['data']['queryAboutContents'];
      console.log("aboutMArt", this.DataAbout);
    })


    this._ContactUsService.watch().valueChanges.subscribe((result:any)=>{
 
      if((result != undefined)&&(result['data']['queryContactUsContents']?.length>0)){
        this.contactData = result['data']['queryContactUsContents'][0];
  
          this.options = {
            mapTypeId: 'hybrid',
            zoomControl: true,
            scrollwheel: true,
            disableDoubleClickZoom: true,
            maxZoom: 20,
            minZoom: 8,
            center: {
              lat: this.contactData?.flatData?.ourLocation?.latitude,
              lng: this.contactData?.flatData?.ourLocation?.longitude
            },
          }
      }
      console.log("conttina", this.contactData)
    });
    

  }


  send(){
    this._FormsService.subscribeForm({
      userEmail:this.email.value
    }).subscribe((res:any)=>{
      if(res != undefined){
        this._ToastService.showSuccess("success")
      }
    })
  }
}
